<template>
  <div class="basic-border">
      <button v-if="!$store.state.isAuthenticated" @click="auth.login" class="login-button">Login with SSO</button>
      <button v-else @click="auth.logout" class="login-button">Log out</button>
      <div class="header">
        <h1  v-if="eventData"> {{ eventData.data_stats.home_team }} vs {{ eventData.data_stats.away_team }}</h1>
        <div class="models-label">
          <h2>Powered by {{ service }} Model: {{ engine }}</h2>
         <h2>Provider: {{ $store.state.isKSP ? 'KSP' : 'Kambi' }}</h2>
          <h2 v-if="$store.state.useAgents">Agents Powered by OpenAI Model: GPT-4o-mini</h2>
        </div>
      </div>
  </div>
</template>

<script>
import auth from "@/auth";

export default {
  name: 'DynamicHeadline',
  computed: {
    auth() {
      return auth
    },
    eventData() {
      return this.$store.state.eventData;
    },
    service() {
      return this.$store.state.service === 'azure' ? 'Azure OpenAI' : 'OpenAI';
    },
    engine() {
      return this.$store.state.engine ? this.$store.state.engine.replace(/_/g, '-') : 'GPT-4o';
    }
  }
};
</script>


<style scoped>
.basic-border {
  border: 2px solid black; /* This adds a bold black border */
  padding: 1em; /* This adds some spacing inside the border */
  margin-bottom: 1em; /* This adds some spacing outside the border */
  /* Rest of your styles */
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 20px;
  margin-left: 20px;
}

.login-button {
   float: right;
  margin-right: 20px;
  margin-left: 20px;
}
</style>